/**
 * Promo tile content for the grid-promo-tiles collection template.
 *
 * Assign the `grid-promo-tiles` theme template to any collection in Shopify,
 * then add or update that collection's handle here.
 *
 * desktopRow is the 4-column row (cols 3–4). mobileRow is the 2-column row,
 * where the tile spans the full width. minProducts hides a later tile until
 * enough products are loaded for that row to exist.
 */
const libreCollectionDesktopImage =
  "https://cdn.shopify.com/s/files/1/0942/9062/files/NewIn-Tiles_Desktop_19_1.jpg?v=1788704438";

const libreCollectionMobileImage =
  "https://cdn.shopify.com/s/files/1/0942/9062/files/NewInTiles_Mobile_11_1.jpg?v=1788704438";

const attimiDesktopImage =
  "https://cdn.shopify.com/s/files/1/0942/9062/files/Attimi_Collection_Tile_Desktop_02.jpg?v=1793093571";

const attimiMobileImage =
  "https://cdn.shopify.com/s/files/1/0942/9062/files/Attimi_Collection_Tile_Mobile-2.jpg?v=1793093576";

const membersDesktopImage =
  "https://cdn.shopify.com/s/files/1/0942/9062/files/Rectangle_51_2.jpg?v=1781523653";

const membersMobileImage =
  "https://cdn.shopify.com/s/files/1/0942/9062/files/Rectangle_51_4_1.jpg?v=1781528943";

const newInTile = {
  titleLines: ["NEW IN"],
  buttonText: "SHOP NOW",
  link: "/collections/new-in",
  images: {
    smallMedia: libreCollectionMobileImage,
    mediumMedia: libreCollectionMobileImage,
    largeMedia: libreCollectionMobileImage,
  },
  desktopImages: {
    smallMedia: libreCollectionDesktopImage,
    mediumMedia: libreCollectionDesktopImage,
    largeMedia: libreCollectionDesktopImage,
  },
};

const attimiTile = {
  titleLines: ["The Attimi Capsule"],
  buttonText: "SHOP NOW",
  link: "/collections/the-attimi-capsule",
  images: {
    smallMedia: attimiMobileImage,
    mediumMedia: attimiMobileImage,
    largeMedia: attimiMobileImage,
  },
  desktopImages: {
    smallMedia: attimiDesktopImage,
    mediumMedia: attimiDesktopImage,
    largeMedia: attimiDesktopImage,
  },
};

export const gridPromoTilesByCollection = {
  all: [
    {
      ...attimiTile,
      desktopRow: 2,
      mobileRow: 4,
    },
    {
      ...newInTile,
      desktopRow: 30,
      mobileRow: 60,
      // 29 desktop rows, minus the Attimi tile's two cells.
      minProducts: 116,
    },
  ],
  "new-in": [
    {
      titleLines: ["MEMBERS", "ONLY"],
      buttonText: "JOIN NOW",
      link: "/pages/members",
      desktopRow: 2,
      mobileRow: 4,
      images: {
        smallMedia: membersMobileImage,
        mediumMedia: membersMobileImage,
        largeMedia: membersMobileImage,
      },
      desktopImages: {
        smallMedia: membersDesktopImage,
        mediumMedia: membersDesktopImage,
        largeMedia: membersDesktopImage,
      },
    },
  ],
};

export function getGridPromoTiles(collectionHandle) {
  if (!collectionHandle) {
    return [];
  }

  return gridPromoTilesByCollection[collectionHandle] ?? [];
}
